import React, { useState } from "react";
import { Button, FormGroup, Input, Row, Col, Card, CardBody } from "reactstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getAPIURL, getVendorID } from "../../services/helper";
import http from "../../services/http";
import {
  addNewProduct,
  setLoading,
} from "../../ReduxToolkit/Reducers/ProductsReducer";
import SelectCategory from "./AddProduct/ProductAdd/SelectCategory";

export default function VariableProductFormView({ product = {} }) {
  const dispatch = useDispatch();
  const api_url = getAPIURL();
  const vendor_id = getVendorID();

  const [productName, setProductName] = useState(product.name || "");
  const [productSKU, setSKU] = useState(product.sku || "");
  const [categories, setCategories] = useState(product.categories || []);

  const onCategoriesChange = (key, value) => {
    setCategories(value);
  };

  const handleAddProduct = async () => {
    if (productName.trim() === "" || productSKU.trim() === "") {
      toast.error("Please enter product name and SKU");
      return;
    }

    const newProduct = {
      id: product.id,
      name: productName,
      sku: productSKU,
      categories: categories.map((cat) => cat.id),
      vendor_id,
    };

    try {
      dispatch(setLoading(true));
      const resp = await http.post(`${api_url}/products/variable`, newProduct);
      dispatch(setLoading(false));

      const { success, data: addedProduct } = resp.data;
      if (!success) return toast.error("Error while adding product");

      dispatch(addNewProduct(addedProduct));
      toast.success("Variable product added successfully");
      setProductName("");
      setSKU("");
    } catch (e) {
      console.error("Error while adding variable product", e);
      dispatch(setLoading(false));
      toast.error("Something went wrong");
    }
  };

  return (
    <Card className="shadow-sm">
      <CardBody>
        <h5 className="mb-3">Add Variable Product</h5>
        <Row>
          <Col md="6">
            <FormGroup>
              <Input
                placeholder="Product Name"
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup>
              <Input
                placeholder="SKU"
                value={productSKU}
                onChange={(e) => setSKU(e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>

        <FormGroup>
          <SelectCategory
            title=""
            value={categories || []}
            onFormChange={onCategoriesChange}
          />
        </FormGroup>

        <Button color="primary" onClick={handleAddProduct}>
          Update Product
        </Button>
      </CardBody>
    </Card>
  );
}
